function noop() { }
export const PENDING = {};
export default class Observable {
    constructor(factory) {
        this.teardown = noop;
        this.observers = [];
        this.hasCompleted = false;
        this.currentValue = PENDING;
        this.factory = factory;
    }
    subscribe(subscriber) {
        const observer = typeof subscriber === 'function'
            ? { next: subscriber, error: noop, complete: noop }
            : subscriber;
        this.observers.push(observer);
        const isFirstSubscription = this.observers.length === 1;
        if (isFirstSubscription) {
            let isAsync = false;
            this.teardown =
                this.factory({
                    next: (value) => {
                        if (this.hasCompleted) {
                            return;
                        }
                        this.currentValue = value;
                        // tslint:disable-next-line:no-increment-decrement
                        for (let i = 0; i < this.observers.length; i++) {
                            this.observers[i].next(value);
                        }
                    },
                    error: (error) => {
                        if (this.hasCompleted) {
                            return;
                        }
                        this.hasCompleted = true;
                        if (isAsync) {
                            this.teardown();
                        }
                        // tslint:disable-next-line:no-increment-decrement
                        for (let i = 0; i < this.observers.length; i++) {
                            this.observers[i].error(error);
                        }
                    },
                    complete: () => {
                        if (this.hasCompleted) {
                            return;
                        }
                        this.hasCompleted = true;
                        if (isAsync) {
                            this.teardown();
                        }
                        // tslint:disable-next-line:no-increment-decrement
                        for (let i = 0; i < this.observers.length; i++) {
                            this.observers[i].complete();
                        }
                    },
                }) || noop;
            isAsync = true;
            if (this.hasCompleted) {
                this.teardown();
                this.teardown = noop;
                this.hasCompleted = false;
                this.currentValue = PENDING;
            }
        }
        else if (this.currentValue !== PENDING) {
            observer.next(this.currentValue);
        }
        let unsubscribed = false;
        return {
            unsubscribe: () => {
                if (unsubscribed || this.hasCompleted) {
                    return;
                }
                // tslint:disable-next-line:no-param-reassign
                unsubscribed = true;
                this.observers.splice(this.observers.indexOf(observer), 1);
                if (this.observers.length === 0) {
                    this.teardown();
                    this.teardown = noop;
                    this.hasCompleted = false;
                    this.currentValue = PENDING;
                }
            },
        };
    }
    static of(value) {
        // tslint:disable-next-line:ter-prefer-arrow-callback
        return new Observable(function factory(observer) {
            observer.next(value);
            observer.complete();
        });
    }
    static from(values) {
        // tslint:disable-next-line:ter-prefer-arrow-callback
        return new Observable(function factory(observer) {
            // tslint:disable-next-line:no-increment-decrement
            for (let i = 0; i < values.length; i++) {
                observer.next(values[i]);
            }
            observer.complete();
        });
    }
    static empty() {
        // tslint:disable-next-line:ter-prefer-arrow-callback
        return new Observable(function factory(observer) {
            observer.complete();
        });
    }
    static never() {
        return new Observable(noop);
    }
    static defer(observableFactory) {
        // tslint:disable-next-line:ter-prefer-arrow-callback
        return new Observable(function factory(observer) {
            const stream = observableFactory();
            const subscription = stream.subscribe(observer);
            return function unsubscribe() {
                subscription.unsubscribe();
            };
        });
    }
}
//# sourceMappingURL=observable.js.map